import { render, staticRenderFns } from "./MenuElement.vue?vue&type=template&id=62f76b90&scoped=true&"
import script from "./MenuElement.vue?vue&type=script&lang=ts&"
export * from "./MenuElement.vue?vue&type=script&lang=ts&"
import style0 from "./MenuElement.vue?vue&type=style&index=0&id=62f76b90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f76b90",
  null
  
)

export default component.exports